import React from 'react';
import styled, { css } from 'styled-components';
import { ThemeTypes } from '../../../theme/theme';
import { heightDesktop, heightMobile } from './constants';
import { useHistory } from "react-router-dom";
import TopmenuProvider from './TopmenuProvider';
import TrilhaConteudoHeader from './TrilhaConteudoHeader';
import { ChannelContext } from '../../../context/channel';

type TypeTopMenu = {
  oneShotLandingPage?: boolean,
  trilhaConteudo?: boolean,
  transparent: boolean,
  logoLightMode: string,
  logoDarkMode?: string,
  isLightMode?: boolean,
  activeLive?: number,
  backgroundImage?: string,
  searchString?: string,
  setSearchString?: React.Dispatch<React.SetStateAction<string>>,
  handleSearch?: () => void
};

interface TypeHeader {
  transparent?: boolean;
  theme: ThemeTypes;
  landingPage?: boolean;
  trilhaConteudo?: boolean;
}

const HeaderStyled = styled('header')<TypeHeader>`
  ${(props: TypeHeader) => css`
    display: flex;
    position: sticky;
    top: 0;
    z-index: 1000;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 16px;
    height: ${heightMobile};
    background-color: ${props.transparent ? 'transparent' : props.theme.colors.topbarBackground};
    border-bottom: ${props.transparent && !props.trilhaConteudo ? 'none' : `1px solid ${props.theme.colors.line}`};

    .desktop-button-rooms {
      display: none;
    }

    .button-topmenu{
      outline: none;
    }

    .right-icon {
      display: none;
    }

    .whitelabel-logo {
      max-height: 35px;
      max-width: 140px;
      cursor: pointer;
    }

    .topbar-wrap-buttons {
      display: flex;
      align-items: center;
      height: 100%;
    }

    button {
      cursor: pointer;
    }

    h1 {
      margin: 0;
      font-weight: 900;
      line-height: 19px;
      font-size: 16px;
      letter-spacing: 10%;
      color: ${props.landingPage ? props.theme.colors.topbarLabelColor : 'black'};
    }

    ${props.theme.mediaQuerie.maxWidth.md} {
      .mobile-hidden {
        display: none;
      }
    }

    ${props.theme.mediaQuerie.minWidth.md} {
      padding-left: 80px;
      padding-right: 80px;
      height: ${heightDesktop};

      .whitelabel-logo {
        max-height: 80px;
        max-width: 132px;
      }

      .right-icon {
        display: block;
      }

      .mobile-close-sidebar {
        display: none;
      }

      .desktop-hidden {
        display: none;
      }

      .desktop-button-rooms {
        display: flex;
      }

      h1 {
        line-height: 21px;
        font-size: 18px;
      }
    }
  `}
`;

const TopMenu = (
  {
    oneShotLandingPage,
    trilhaConteudo,
    transparent,
    logoLightMode,
    logoDarkMode,
    isLightMode,
    activeLive,
    backgroundImage,
    searchString,
    setSearchString,
    handleSearch
  }: TypeTopMenu) =>
  {
  const { username } = React.useContext(ChannelContext)
  let component = null;
  let history = useHistory();

  component = <TrilhaConteudoHeader key="trilhaConteudo" searchString={searchString} setSearchString={setSearchString} handleSearch={handleSearch}/>;

  const handleClickLogo = () => {
    if(username){
      history.replace('/' + username)
    }
  }

  return (
    <TopmenuProvider transparent={transparent}>
      <HeaderStyled
        transparent={transparent}
        trilhaConteudo={trilhaConteudo}
        landingPage={oneShotLandingPage}
      >
        {! isLightMode && logoDarkMode ? (
          <img onClick={() => handleClickLogo()} className="whitelabel-logo" src={logoDarkMode} alt="whitelabel-logo" />
        ) : (
          <img onClick={() => handleClickLogo()} className="whitelabel-logo" src={logoLightMode} alt="whitelabel-logo" />
        )}
        <div className="topbar-wrap-buttons">{component}</div>
      </HeaderStyled>
    </TopmenuProvider>
  );
};

TopMenu.defaultProps = {
  trilhaConteudo: false,
  oneShotLandingPage: true,
  logo: '',
};

export default TopMenu;
